export default function (notifiche) {
  this.idMessaggio = notifiche ? notifiche.idMessaggio : null;
  this.DataMessaggio = notifiche ? notifiche.DataMessaggio : null;
  this.DataInvio = notifiche ? notifiche.DataInvio : null;
  this.TipoMessaggio = notifiche ? notifiche.TipoMessaggio : null;
  this.TitoloMessaggio = notifiche ? notifiche.TitoloMessaggio : null;
  this.Messaggio = notifiche ? notifiche.Messaggio : null;
  this.AzioneMessaggio = notifiche ? notifiche.AzioneMessaggio : null;
  this.username = notifiche ? notifiche.username : null;
  this.deviceId = notifiche ? notifiche.deviceId : null;
  this.deviceType = notifiche ? notifiche.deviceType : null;
}
